import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from '@/App.vue';
import * as echarts from 'echarts';
import 'echarts-liquidfill';
import Katex from '@/pages/dl-web/utils/directives';
import 'katex/dist/katex.min.css';
import _ from 'lodash';
import store from './store';
import router from './router';

Vue.prototype.$echarts = echarts;
Vue.prototype.bus = new Vue();
Vue.prototype.$get = _.get;
Vue.use(Katex);

Vue.config.productionTip = false;

Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
